export const CASH_PAY_TYPE_ID = "1";
export const TYRO_TYPE_ID = "10";
export const DEV_TYRO_TYPE_ID = "15";
export const LINKLY_TYPE_ID = "30";
export const TOWER_PAYMENTS_TYPE_ID = "40";
export const ROAM_LOCATION_HEADER_KEY = "x-roam-location-token";
